var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import * as React from 'react';
import { bind } from 'bind-decorator';
export class Canvas extends React.Component {
    constructor() {
        super(...arguments);
        Object.defineProperty(this, "canvas", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
    }
    render() {
        return (React.createElement("canvas", { ref: this.setRef, width: this.props.width * 2, height: this.props.height * 2, className: this.props.className }));
    }
    setRef(e) {
        if (!e) {
            return;
        }
        this.canvas = e;
    }
    updateCanvas() {
        const context = this.canvas.getContext('2d');
        context.scale(2, 2);
        this.props.updateCanvas(this.canvas, context);
    }
    /*------ Lifecycles ------*/
    componentDidMount() {
        this.updateCanvas();
    }
    componentWillReceiveProps(nextProps) {
        if (this.props !== nextProps) {
            this.updateCanvas();
        }
    }
}
__decorate([
    bind
], Canvas.prototype, "setRef", null);
